import React from 'react';
import { useSelector } from 'react-redux';

import SectionViewTracker from 'dpl/common/components/SectionViewTracker';
import LocationAndPickup from 'dpl/components/BreederProfile/mobile/components/shared/LocationAndPickup';

export default function BreederProfileDeliverySectionContainer() {
  const { breederProfileId, analyticsPageName } = useSelector(
    ({ server }) => server
  );

  return (
    <SectionViewTracker
      name={analyticsPageName}
      category="breeder-profile-transport"
      properties={{ breeder_profile_id: breederProfileId }}
    >
      <div className="BreederProfileDeliverySectionContainer container-xxl mv8 mv20-md">
        <LocationAndPickup />
      </div>
    </SectionViewTracker>
  );
}
